module.exports = __webpack_public_path__ + "img/1_bg_noatm.2fd2f585.png";